import { render, staticRenderFns } from "./OfficerJenny.vue?vue&type=template&id=8fb51b46"
import script from "./OfficerJenny.vue?vue&type=script&lang=js"
export * from "./OfficerJenny.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports